import axios from "axios";
import Cookies from "js-cookie";

// Configure default axios instance
const configureAxios = () => {
  // Set base URL
  axios.defaults.baseURL = process.env.REACT_APP_BACKEND_URL || "http://localhost:8000/api";

  // Get token from cookies or localStorage
  const getToken = () => {
    const userCookie = Cookies.get("user");
    if (userCookie) {
      try {
        const user = JSON.parse(userCookie);
        return user.token;
      } catch (e) {
        console.error("Error parsing user cookie:", e);
        return null;
      }
    }
    return null;
  };

  // Request interceptor to add token
  axios.interceptors.request.use(
    (config) => {
      const token = getToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Response interceptor to handle 401 errors
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        // Token expired or invalid - clear user data
        Cookies.remove("user");
        window.location.href = "/login";
      }
      return Promise.reject(error);
    }
  );
};

export default configureAxios;
